import React, {useEffect, useState} from 'react';

//styling
import './counter.scss';

const Counter = props => {
  // label of counter
  // number to increment to
  // duration of count in seconds
  const {label, number, duration, unit} = props.data

  // number displayed by component
  const [count, setCount] = useState("0")

  useEffect(() => {
    let start = 0;
    // first three numbers from props
    const end = parseInt(number.substring(0, 3))
    // if zero, return
    if (start === end) return;

    // find duration per increment
    let totalMilSecDur = parseInt(duration);
    let incrementTime = (totalMilSecDur / end) * 1000;

    // timer increments start counter
    // then updates count
    // ends if start reaches end
    let timer = setInterval(() => {
      start += 1;
      setCount(String(start) + number.substring(3))
      if (start === end) clearInterval(timer)
    }, incrementTime);

    // dependency array
  }, [number, duration]);

  const classnames= ['Count']
  if(props.active){
    classnames.push('active')
  }

  return (
    <div className={classnames.join(' ')}>
      <h1>
        {count}{unit}+
      </h1>
      <h3>
        {label}
      </h3>

    </div>
  );
}

export default Counter;